export enum SmsLogReportTypeEnum {
  ALL = "ALL",
  PENDING = "PENDING",
  DELIVERED = "DELIVERED",
  NOT_DELIVERED = "NOT_DELIVERED",
  FUTURE_SMS = "FUTURE_SMS"
}
